import { Building2Icon } from '@/components/ui/icons'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { PageContainer } from '@/components/layout/page-container'
import { ComingSoonCard } from '@/features/account-hub/components/coming-soon-card'

export const Route = createFileRoute('/_app/suppliers/')({
  component: SuppliersPage,
})

function SuppliersPage(): JSX.Element {
  return (
    <PageContainer>
      <ComingSoonCard
        icon={<Building2Icon />}
        title="Proveedores"
        description="Aquí podrás registrar y gestionar a tus proveedores — las personas o empresas de quienes recibes bienes o servicios."
      />
    </PageContainer>
  )
}
